import type { ButtonProps } from "antd";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import {
  useDatasetsMutatorActions,
  useDatasetsMutatorStatus,
} from "@/modules/datasets/datasets-mutator";

const DatasetsMutatorSaveButton = ({
  onClick,
  ...buttonProps
}: ButtonProps) => {
  const { t } = useTranslation();
  const { isDirty } = useDatasetsMutatorStatus();
  const { saveMutations } = useDatasetsMutatorActions();

  if (!isDirty) return;

  const onButtonClick: ButtonProps["onClick"] = (e) => {
    saveMutations();
    onClick?.(e);
  };

  return (
    <Button type="primary" {...buttonProps} onClick={onButtonClick}>
      {t("global:save")}
    </Button>
  );
};

export default DatasetsMutatorSaveButton;
